import { render, staticRenderFns } from "./taskPreview.vue?vue&type=template&id=1bcbfcf4&scoped=true&"
import script from "./taskPreview.vue?vue&type=script&lang=js&"
export * from "./taskPreview.vue?vue&type=script&lang=js&"
import style0 from "./taskPreview.vue?vue&type=style&index=0&lang=css&"
import style1 from "./taskPreview.vue?vue&type=style&index=1&id=1bcbfcf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcbfcf4",
  null
  
)

export default component.exports